export default __webpack_public_path__ + "static/media/sign_up_head3.666c4c2c.png";